import Field, { type Flavor } from '../../Field';
import terminology from 'javascripts/terminology';
import { type CardLayoutModelType } from '../../types';
import { type FieldContentsData } from 'javascripts/shared-types';

type GoalIconModel = Extract<CardLayoutModelType, { goals: any[] }>;

export class GoalIcon extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap'];
  }

  static subqueriesForModel(modelClass) {
    // KeyResult has a singular goal, others have goals array
    if (modelClass.typename === 'KeyResult') {
      return { goal: ['color'] };
    }
    return { goals: ['color'] };
  }

  get title() {
    return `${terminology('Goal')} icon`;
  }

  exampleContents(): FieldContentsData {
    return {
      icon: { name: 'fa-solid fa-flag', color: '#B540BF' },
    };
  }

  contentsForRecord(record: GoalIconModel): FieldContentsData {
    let goal;

    if ('goal' in record) {
      goal = record.goal;
    } else {
      goal = record.goals?.[0];
    }

    if (goal) {
      return {
        icon: {
          name: 'fa-solid fa-flag',
          color: goal.colorObject.hex(),
        },
      };
    }

    return {};
  }
}
